import React, { useEffect } from 'react';
import PageGraphic from '../components/PageGraphic';
import imgGrpahic from '../assets/img/firm.png';
import { Wrapper } from './Landing';
import Quote from '../components/Quote';

const Firm = () => {
  useEffect(() => {
    document.title = 'Emprouen Advisors: Firm';
  }, []);

  return (
    <Wrapper>
      <PageGraphic src={imgGrpahic} />
      <div>
        <h2>Firm</h2>

        <Quote>Real success depends on holistic operational excellence.</Quote>

        <p>
          We are a transformational advisory firm that listens and focuses.
          We’re not afraid to ask the hard questions, and we bring staying power
          and a deep professional bench to deliver evolution without revolution.
          Our approach is rooted in operational excellence with a constant eye
          on financial performance. We understand urgency, and our services are
          only as good as the value we provide.
        </p>

        <p>
          We are industry professionals in manufacturing, distribution and
          retail verticals, experienced as executives and hands-on leaders. We
          create sustainable operational and financial improvements though
          aligned strategy and tactics.
        </p>

        <p>
          Advisory firms typically approach engagements seeking to provide
          quick, superficial successes. They fear getting deep into the weeds to
          understand their clients’ fundamental issues and achieve their true
          goals. We take a contrarian view &ndash; any advisor worth their fees
          must pursue a deeper understanding of their clients challenges. This
          is just as true for companies going through a transaction as for those
          in any other stage of the business lifecycle, and it guides our entire
          approach. With a long view and hands-on expertise, we help investors,
          owners, boards and leaders turn their organizations into industry
          leading powerhouses.
        </p>

        <p>
          While our practice is grounded in advanced management, operational,
          and financial principles, we’re not held back by them. Our work is
          most effective when we get deep into the true performance of a
          company. Our holistic approach spans every aspect of the business, we
          consistently stress success factors – outstanding cultures, resource
          utilization, process standards and financial controls to ensure an
          entire organization is headed in the same direction.
        </p>
      </div>
    </Wrapper>
  );
};

export default Firm;
